import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import { useBlockScroll } from "@helpers/hooks/useBlockScroll";

interface IModalProps {
  visible: boolean;
  onClose: () => void;
  children?: ReactNode;
}

const EnlargeImageModal: FC<IModalProps> = ({ visible, onClose, children }) => {
  useBlockScroll();

  const overlayRef = useRef<HTMLDivElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);
  const [showScrollBar, setShowScrollBar] = useState(false);
  const handleOpenModal = () => {
    overlayRef.current?.classList.remove("hidden");
    setTimeout(() => {
      modalRef.current?.classList.remove("opacity-0", "scale-50");
      modalRef.current?.classList.add("scale-100");
    }, 100);

    // When scroll bar is shown by default, the animation is not looking good in some windows machine.
    setTimeout(() => {
      setShowScrollBar(true);
    }, 1000);
  };

  const handleCloseModal = () => {
    modalRef.current?.classList.add("scale-50");
    setTimeout(() => {
      modalRef.current?.classList.add("opacity-0");
      overlayRef.current?.classList.add("hidden");
    }, 500); // Match the duration of the transition
    setShowScrollBar(false);
    onClose && onClose();
  };

  const handleEscape = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      onClose();
    }
  };

  useEffect(() => {
    if (visible) {
      document.addEventListener("keydown", handleEscape);
      handleOpenModal();
    } else {
      document.removeEventListener("keydown", handleEscape);
      handleCloseModal();
    }
  }, [visible]);

  return (
    <div>
      <div
        id="modal_overlay"
        ref={overlayRef}
        className="fixed inset-0 z-50 w-full h-full bg-black bg-opacity-50 flex items-center justify-center"
      >
        <div
          id="modal"
          ref={modalRef}
          className="bg-white bg-opacity-90 h-full w-full opacity-0 transform scale-50 transition-all duration-500 lg:bg-transparent"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <div
            className={`${
              showScrollBar ? "overflow-y-auto" : ""
            } h-full w-full flex items-center justify-items-center justify-center`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnlargeImageModal;
